import { useKindeAuth } from '@kinde-oss/kinde-auth-react'

/**
 * Hook to access Kinde authentication state and methods.
 * Re-exports useKindeAuth for convenience.
 */
export function useAuth() {
  return useKindeAuth()
}
